const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');


const Row = ({ children, className, ...props }) => (
    <article className={classNames('vertical-accordion', className)} {...props}>
        {children}
    </article>
);


Row.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
};


module.exports = Row;
